import { useMemo } from 'react';
import type { DeploymentItem } from '../../components/message-composer/chat-context/selectors';
import type { DashboardProduct } from '../../dashboard/products';

import { usePortalInstanceDirectory } from './usePortalInstanceDirectory';

/**
 * The customers owning the instances of this product scope — a group-by over the directory, the
 * portal having no customer endpoint. The name is its own id: `account` is a bare string.
 */
export const useCustomerOptions = (
  products: DashboardProduct[] = [],
): {
  items: DeploymentItem[];
  totalCount: number;
  status: 'loading' | 'success' | 'error';
  isPortalSource: boolean;
} => {
  const { customers, status, isPortalSource } = usePortalInstanceDirectory(products);

  const items = useMemo(() => customers.map((customer) => ({ id: customer, label: customer })), [customers]);

  return useMemo(() => ({ items, totalCount: items.length, status, isPortalSource }), [items, status, isPortalSource]);
};
